import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {PaymentStatusService} from "../pages/payment-list/services/payment-status.service";

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  isModalOpen$: Subject<boolean> = new BehaviorSubject<boolean>(false)

  constructor(
    private paymentStatusService: PaymentStatusService
  ) {
  }

  openModal() {
    this.isModalOpen$.next(true)
  }

  closeModal() {
    this.isModalOpen$.next(false)
    this.paymentStatusService.paymentStatusService$.next(null)
  }
}
